import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Mistakes } from './components/Mistakes';
import { Pillars } from './components/Pillars';
import { Areas } from './components/Areas';
import { GuideOverview } from './components/GuideOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { NoStartFromZero } from './components/NoStartFromZero';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { NextSteps } from './components/NextSteps';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <TopBar data-id="element-1" data-mp="3ijfx0558q6h9" />
      <main data-id="element-2" data-mp="3ijpet5g4t7bv">
        <Hero data-id="element-3" data-mp="3ii4s22026sok" />
        <Problems data-id="element-4" data-mp="3mlawd43m29se" />
        <Mistakes data-id="element-5" data-mp="3mkrdnl64zhdb" />
        <Pillars data-id="element-6" data-mp="3mk85uxa7a9d0" />
        <Areas data-id="element-7" data-mp="3mjq27fl7ksv2" />
        <GuideOverview data-id="element-8" data-mp="3mj6ibtbzzuee" />
        <Modules data-id="element-9" data-mp="3rcj8i7wbs999" />
        <Bonuses data-id="element-10" data-mp="3rbznujfaj6rj" />
        <NoStartFromZero data-id="element-11" data-mp="3rdkh85pvcjnt" />
        <About data-id="element-12" data-mp="3recd7hndojem" />
        <Testimonials data-id="element-13" data-mp="5yjetptzbev" />
        <Offer data-id="element-14" data-mp="6hpnd64cbd2" />
        <NextSteps data-id="element-15" data-mp="4wx1t3d72hu" />
        <Faq data-id="element-16" data-mp="5ggxfcks0yi" />
      </main>
      <Footer data-id="element-17" data-mp="7st1bvnjh3n" />
      <PurchasePopup data-id="element-18" data-mp="2zld0l5ad579f" />
    </div>;
}